import user6 from '../assets/img/user6.png';
import user5 from '../assets/img/user5.png';
import { v4 as uuidv4 } from 'uuid';
import AccountService from './AccountService';
import WorkspaceService from './WorkspaceService';
import { getJson, postJson, putJson } from './ServiceHelperMethods';
import { useState } from 'react';
import { useEffect } from 'react';
import AuthService from './auth';
import { store } from '../redux/store';
import { getWorkspaces } from '../redux/slices/WorkspaceSlice';
import { getModels } from '../redux/slices/ModelSlice';
import { getAccounts } from '../redux/slices/AccountSlice';
import { getModelTypes } from '../redux/slices/ModelTypeSlice';
import { getDataTypes } from '../redux/slices/DataTypeSlice';

const DUMMY_USER = {
    email: '',
    user_id: sessionStorage.getItem("USERID") ?? 't' + uuidv4(),
    name: 'Guest',
    picture: user6,
    isFalseUser: true
}

class UserService {

    static errored = false;
    static initializing = false;
    static initialized = false;
    static prom = null;
    static me = null;

    static async initializeGuestUser(userId) {

        const fakeAccount = {
            title: "My Account",
            collaborators: [userId],
        }

        const accounts = await AccountService.createAccounts([fakeAccount])
        console.log(accounts)
        const accountId = accounts[0]._id

        const fakeWorkspace = {
            title: "My Workspace",
            account: accountId,
            picture: user5,
            members: [{ userId, role: 'owner' }],
        }

        await WorkspaceService.createWorkspaces([fakeWorkspace])
    }

    static async getUserData(userId) {
        return await getJson(`userdata/${userId}`);
    }

    static async setUserData(userData) {
        return await putJson(`userdata`, userData);
    }

    static async mergeUsers(tempUserId) {
        return await postJson(`userdata/mergeUsers/${tempUserId}`);
    }

    static async setUserDataProp(propName, val) {
        var userData = UserService?.me?.userData;
        userData[propName] = val;
        UserService.me.userData = userData;
        return await UserService.setUserData(userData);
    }

    static async initialize() {

        if (!UserService.pme && !UserService.prom) {
            UserService.initializing = true
            const p = async () => {
                try {
                    // Was this here to prevent race condition?
                    // await new Promise(r => setTimeout(r, 20));

                    // MAKE THIS THE ELSE CASE IF AUTH0 CANNOT FIND USER
                    UserService.me = DUMMY_USER;

                    let userId = sessionStorage.getItem("USERID");

                    if (!userId) {
                        await UserService.initializeGuestUser(DUMMY_USER?.user_id);
                        sessionStorage.setItem("USERID", DUMMY_USER?.user_id);
                    }

                    const userData = await UserService.getUserData(userId);

                    UserService.me = {
                        ...DUMMY_USER,
                        userData: userData
                    }

                    console.log("Current User: ", UserService.me)
                    return true
                }
                catch (err) {
                    console.log(err)

                    UserService.initializing = false
                    UserService.initialized = true
                    UserService.errored = true
                    return false
                }
            }

            UserService.prom = p()
        }
        return await UserService.prom
    }

    static getMe() {
        return UserService.me
    }

    // TODO: Need to disallow users from getting each others information
    // This should not need to pass the user ID. We should be able to use the token to get the user ID
    static async getUserHeader() {

        var header = { "x-userid": UserService.me?.user_id }

        if (!(UserService.me?.isFalseUser)) {
            console.log("Getting token")
            const token = await AuthService.getAuthToken()
            console.log("Token acquired")
            header["Authorization"] = `Bearer ${token}`
        }

        return header
    }

    static getUser(id) {
        var user = {
            email: '',
            name: 'Deleted User',
            picture: user6,
            user_id: id,
            isFalseUser: true
        }

        return user
    }

    static getOrgUsers() {
        var users = [
            {
                email: 'gas6262@hotmail.com',
                name: 'Deleted User',
                picture: user6,
                user_id: id,
                isFalseUser: true
            }
        ]

        return users
    }

    static async getOrCreateUser(user) {

    }
}

export default UserService;